import PropTypes from 'prop-types';
import React from 'react';

export default function Option({ getLabel, view, handleChange }) {
	const options = [
		{
			value: 'grid',
			label: getLabel('layout_grid'),
			classes: 'option' + (view === 'grid' ? ' selected' : ''),
		},
		{
			value: 'list',
			label: getLabel('layout_list'),
			classes: 'option' + (view === 'list' ? ' selected' : ''),
		},
	];

	const getOption = (option) => {
		return (
			<li className={option.classes} onClick={handleChange}>
				<span>{option.label}</span>
			</li>
		);
	};

	return (
		<div className="feature__controls--option">
			<ul className="mcfly-options mcfly-options--small" data-value={view}>
				{options.map((option, index) => (
					<React.Fragment key={index}>{getOption(option)}</React.Fragment>
				))}
			</ul>
		</div>
	);
}

Option.propTypes = {
	getLabel: PropTypes.func,
	view: PropTypes.string,
	handleChange: PropTypes.func,
};
